import { Schema } from 'mongoose';

export const salesBaseSchema = new Schema(
  {
    kind: { type: String, enum: ['Project', 'Property'] },
    soldBy: { type: Schema.Types.ObjectId, ref: 'User' },
    salesAt: { type: Date },
    notes: { type: String },
  },
  { _id: false, discriminatorKey: 'kind' },
);

export const projectSaleSchema = new Schema(
  {
    project: { type: Schema.Types.ObjectId, ref: 'Project' },
  },
  { _id: false },
);

export const propertySaleSchema = new Schema(
  {
    property: { type: Schema.Types.ObjectId, ref: 'individualProperties' },
  },
  { _id: false },
);
